var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import equal from 'deep-equal';
import { action, computed, observable, makeObservable } from 'mobx';
import * as React from 'react';
import API from '../../util/ApiUtil';
export default class PersonPasswordStore extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "personPassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { passwordHint: '', password: '' }
        });
        Object.defineProperty(this, "newPassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { passwordHint: '', password: '' }
        });
        Object.defineProperty(this, "isSaveSuccessful", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITIALIZED'
        });
        Object.defineProperty(this, "customerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loadPersonPassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                if (!this.shouldFetchPassword()) {
                    return Promise.resolve();
                }
                this.customerId = this.props.ssoStore.customerId;
                return this.fetchPersonPassword();
            }
        });
        Object.defineProperty(this, "updatePassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (!this.newPassword.password) {
                    return API.delete('/person-data/password').then(() => {
                        return this.fetchPersonPassword();
                    });
                }
                return API.put('/person-data/password', this.newPassword).then(() => {
                    this.isSaveSuccessful = true;
                    return this.fetchPersonPassword();
                });
            }
        });
        Object.defineProperty(this, "changePassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (password) => {
                this.isSaveSuccessful = false;
                this.newPassword.password = password;
            }
        });
        Object.defineProperty(this, "changeHint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (hint) => {
                this.newPassword.passwordHint = hint;
            }
        });
        Object.defineProperty(this, "fetchPersonPassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.status = 'FETCHING';
                return API.get('/person-data/password').then(this.handleSuccess).catch(this.handleError);
            }
        });
        Object.defineProperty(this, "handleSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (response) => {
                if (response.data) {
                    this.personPassword = response.data;
                    this.newPassword = response.data;
                }
                else {
                    this.personPassword = { passwordHint: '', password: '' };
                    this.newPassword = { passwordHint: '', password: '' };
                }
                this.status = 'FETCHED';
            }
        });
        Object.defineProperty(this, "handleError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (error) => {
                this.personPassword = { password: '', passwordHint: '' };
                this.status = 'ERROR';
                console.error(error);
            }
        });
        Object.defineProperty(this, "shouldFetchPassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.customerId !== this.props.ssoStore.customerId || ['UNINITIALIZED', 'ERROR'].includes(this.status);
            }
        });
        makeObservable(this);
    }
    get canUpdatePassword() {
        return !equal(this.newPassword, this.personPassword);
    }
}
__decorate([
    observable
], PersonPasswordStore.prototype, "personPassword", void 0);
__decorate([
    observable
], PersonPasswordStore.prototype, "newPassword", void 0);
__decorate([
    observable
], PersonPasswordStore.prototype, "isSaveSuccessful", void 0);
__decorate([
    observable
], PersonPasswordStore.prototype, "status", void 0);
__decorate([
    observable
], PersonPasswordStore.prototype, "customerId", void 0);
__decorate([
    action.bound
], PersonPasswordStore.prototype, "loadPersonPassword", void 0);
__decorate([
    action.bound
], PersonPasswordStore.prototype, "changePassword", void 0);
__decorate([
    action.bound
], PersonPasswordStore.prototype, "changeHint", void 0);
__decorate([
    computed
], PersonPasswordStore.prototype, "canUpdatePassword", null);
__decorate([
    action.bound
], PersonPasswordStore.prototype, "fetchPersonPassword", void 0);
__decorate([
    action.bound
], PersonPasswordStore.prototype, "handleSuccess", void 0);
__decorate([
    action.bound
], PersonPasswordStore.prototype, "handleError", void 0);
